import { getErrorMessage } from '../../errorBuilder';
import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getClientDashboardStats = async () => {
  const builder = new UrlBuilder(`/clients/get-statistics`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const regenerateClientCode = async () => {
  const builder = new UrlBuilder(`/clients/regenerate-client-code`);

  try {
    const response = await post(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
